module.exports = __webpack_public_path__ + "img/AP_WindSlab.8a17c3e6.svg";